import { useEffect, useState } from 'react'
import styledCSSThemes from '~/themes'

import useCurrentUser from './useCurrentUser'
import { useCurrentUserSetting } from './useCurrentUserSetting'

window.globalTheme = 'light'
const DARK_THEME = 'dark'
const LIGHT_THEME = 'light'
const themes = [DARK_THEME, LIGHT_THEME]

function getResolvedTheme(): typeof DARK_THEME | typeof LIGHT_THEME {
  try {
    const saved = localStorage.getItem('happitu-theme')
    if (saved === DARK_THEME) return DARK_THEME
    if (saved === LIGHT_THEME) return LIGHT_THEME
  } catch (e) {}
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return DARK_THEME
  }
  return LIGHT_THEME
}

export function useLegacyTheme() {
  const currentUser = useCurrentUser()
  const [userTheme] = useCurrentUserSetting('session', 'theme', 'auto')
  const [currentTheme, setTheme] = useState<keyof typeof styledCSSThemes>(
    getResolvedTheme,
  )

  useEffect(() => {
    if (!currentUser) return
    const themeColor = styledCSSThemes[currentTheme].colors.background
    window.globalTheme = currentTheme
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', themeColor)
    try {
      localStorage.setItem('happitu-theme', currentTheme)
    } catch (e) {}
  }, [currentTheme, currentUser])

  useEffect(() => {
    if (!currentUser) return

    const root = window.document.documentElement
    root.classList.remove(...themes)

    const osColorSchemeChange = (event: MediaQueryListEvent) => {
      root.classList.remove(...themes)
      if (event.matches) {
        root.classList.add(DARK_THEME)
        setTheme(DARK_THEME)
      } else {
        root.classList.add(LIGHT_THEME)
        setTheme(LIGHT_THEME)
      }
    }

    if (Object.keys(styledCSSThemes).includes(userTheme)) {
      root.classList.add(userTheme)
      setTheme(userTheme as keyof typeof styledCSSThemes)
    } else {
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches
      ) {
        root.classList.add(DARK_THEME)
        setTheme(DARK_THEME)
      } else {
        root.classList.add(LIGHT_THEME)
        setTheme(LIGHT_THEME)
      }

      window
        .matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', osColorSchemeChange)
    }

    return () => {
      window
        .matchMedia('(prefers-color-scheme: dark)')
        .removeEventListener('change', osColorSchemeChange)
    }
  }, [userTheme, currentUser])

  return styledCSSThemes[currentTheme]
}
